import { Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { CurrencyPurchaseService } from "./fp-order-purchase/service/currency-purchase.service";
import { FpCurrencyPurchaseComponent } from "./fp-order-purchase/fp-currency-purchase.component";
import { FpOrderTrackingComponent } from "./fp-order-tracking/fp-order-tracking.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'app-fp-order-panel.',
    imports: [CommonModule, ReactiveFormsModule, FpCurrencyPurchaseComponent, FpOrderTrackingComponent, TranslateModule],
    templateUrl: './fp-order-panel.component.html',
    styleUrl: './fp-order-panel.component.scss'
})
export class FpOrderPanelComponent {
activeTab: 'buy' | 'tracking' = 'buy';

    constructor(
        public _currencyPurchaseService: CurrencyPurchaseService
    ) {

    }

    ngOnInit() {
        this._currencyPurchaseService.init();
    }

}